<script>
import Layout from "../../../../layouts/manage";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import { expenseCategoryService } from "../../../../../services/managements/expenses/expensecategory.service";

import List from "../../../../../components/list";
import Screen from "../../../../../components/screen";
import i18n from "../../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
    extends:Screen,
    page: {
        title: "Expense Category List",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader, List },
    data() {
        return {
        data: {},
        typeList: {},
        fetchingStats: false,
        title: "Expense Category List",

        };
    },
    mounted() {
        this.loadingData();
    },

    methods: {
        loadingData: function(param = '') {
            this.fetchingStats = false;
            expenseCategoryService.getList(param)
                .then(response => {
                
                this.fetchingStats = true;
                this.data = response;
                // console.log(this.data)
            });
        },


        deleted: function(id) {
        expenseCategoryService.remove(id)
            .then(response => {
            if(response.status == 200) {
                this.$swal.fire({
                title: i18n.t('general.confirm.deleted'),
                text: i18n.t('general.confirm.success'),
                icon: "success",
                confirmButtonText: i18n.t('general.ok')
                });
            }
            });
        },

        pageNavigate: function(param) {
            this.loadingData(param);
        },

        submitAdd: function() {
        this.$router.push(this.$route.query.redirectFrom || {
                name: "manage-expense-category-add",
            });
        },

    }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'manage-expense-category-add'}" :title="$t('manage.expense-category.text')" />
    <div v-if="data">
        <List v-bind:dataList="data" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[{name:'price', type: 'currency'}]"
          v-bind:fields="[ 
            `name: ${$t('manage.service.name')}`,
            `name_en: ${$t('manage.name_en')}`,
          ]"
          v-bind:deletes="[deleted, null]"
          v-bind:edit="{link: 'manage-expense-category-edit'}"
          v-bind:filter="{
            search: ['manage_expense_categories.name','manage_expense_categories.name_en'],
          }"
          
    />      
    </div>
  </Layout>
</template>